// extracted by mini-css-extract-plugin
export default {"container":"FK","productarea":"GK","btn":"HK","promowrapper":"IK","upsellarea":"JK","subtitle":"KK","system":"LK","desc":"MK","cardswrap":"NK","cards":"OK","squareloadingcontainer":"PK","squareloading33":"QK"};
    if(module.hot) {
      // 1715091679891
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  